import { border, color, rem, Theme } from '@thiememeulenhoff/lit-sdk';
import * as token from '@thiememeulenhoff/tokens/core';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('header');
export const theme = new Theme(tag);

export const styles = css`
  :host {
    align-items: stretch;
    background-color: ${color('white')};
    border-block-end: ${border(1, 'grey', 400)};
    display: flex;
    inline-size: 100%;
    inset-block-start: 0;
    justify-content: space-between;
    padding: ${rem(0, 16)};
    position: fixed;
    transition: top 0.2s ease-in-out;
    ${theme.props([['min-block-size', 'min-block-size', rem(50)]])};
    z-index: 9999;
  }

  :where(a-logo-icon),
  ::slotted([slot='logo']) {
    inline-size: ${rem(40)};
  }

  :where(section) {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 auto;
    gap: ${rem(8)};
    padding: ${rem(8, 0)};
  }

  :where(.logo) {
    flex: 0 0 auto;
    margin-inline-end: ${rem(32)};
  }

  :host([padding='false']) :where(section) {
    gap: 0;
    padding: 0;

    &:where(.start) a-logo-icon,
    &:where(.start) .stream-logo,
    &:where(.start) .stream-title {
      padding-inline-end: ${rem(8)};
    }
  }

  :where(.bypass-block a) {
    block-size: ${rem(1)};
    color: ${color('blue')};
    inset-block-start: auto;
    overflow: hidden;
    position: absolute;
  }

  :where(.bypass-block) {
    flex: 0 0 auto;
  }

  :where(.bypass-block a:focus) {
    background-color: ${color('white', 100)};
    block-size: auto;
    border: ${border(2, 'blue', 500)};
    border-radius: ${rem(5)};
    inline-size: auto;
    inset-block-start: ${rem(75)};
    outline: none;
    padding: ${rem(5)};
    position: absolute;
    text-decoration: none;
  }

  :where(.start) {
    justify-content: flex-start;
  }

  :where(.center) {
    justify-content: center;
  }

  :where(.end) {
    justify-content: flex-end;
  }

  :where(.stream-title) {
    font-size: ${rem(18)};
    line-height: 1;
  }

  :where(.stream-logo) {
    max-block-size: ${rem(32)};
    max-inline-size: ${rem(120)};
  }

  @media (max-width: ${unsafeCSS(token.BreakpointSmall)}) {
    :host {
      flex-wrap: wrap;
    }

    :where(.center) {
      justify-content: flex-start;
    }
  }
`;
